import React, { useContext, useMemo } from "react";
import Carousel from 'react-bootstrap/Carousel'
import { useSelector } from 'react-redux';
import { Col, Row, Container } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTv, faPhone, faMusic, faWheelchair, faKey, faFan, faTemperatureHigh, faClock, faVoicemail, faCheckCircle, faCheck } from '@fortawesome/free-solid-svg-icons';

import { getCDNImage } from '../globals';
import TitleBar from '../components/TitleBar';
import { i18nValue, mergeHotelAndCheckinPlaceholders } from '../functions';
import { T } from "react-translator-component";
import { HotelContext } from '../context/hotel'
import { CheckInContext } from '../context/checkin';
import Screen from '../components/Screen';
import { UserContext } from "../context/user";
import { isHostzArosa } from "../components/CheckIn/hotelConditions";
import SocialLinks from "../components/SocialLinks";
import SectionBlocksRenderer from "../components/Sections/SectionBlocksRenderer";

// const amenitiesTranslate = {
//   'conditioning-air-in-commons-spaces' : 'Aire acondicionado en espacios comunes',
//   'parking' : 'Aparcamiento',
//   'free-parking' : 'Aparcamiento gratuito',
//   'bar' : 'Bar',
//   'aesthetic-Center' : 'Centro de estetica',
//   'kids-club' : 'Club para niños',
//   'luggage-storage' : 'Consigna de equipaje',
//   'breakfast' : 'Desayuno',
//   'breakfast-buffet' : 'Desayuno Buffet',
//   'smoke-free-space' : 'Espacio libre de humo',
//   'fitness-center' : 'Fitness center',
//   'gay-friendly' : 'Gay Friendly',
//   'general' : 'General',
//   'hydromassage' : 'Hidromasaje',
//   'gardens' : 'Jardines',
//   'masseuse-available' : 'Masajista disponible',
//   'water-park' : 'Parque acuatico',
//   'hairdressing' : 'Peluqueria',
//   'bilingual-staff-english-spanish' : 'Personal bilingüe (Ingles/Español)',
//   'pet-friendly' : 'Pet Friendly',
//   'pool' : 'Piscina',
//   'smoking-points' : 'Puntos de fumador',
//   'reception-24-hs' : 'Recepcion 24hs',
//   'restaurant' : 'Restaurant',
//   'restaurant-to-the-card' : 'Restaurant a la carta',
//   'theme-restaurant' : 'Restaurant tematico',
//   'congress-hall' : 'Sala de congresos',
//   'sauna' : 'Sauna',
//   'laundry-service' : 'Servicio de Lavanderia',
//   'babycare-service' : 'Servicio de Guarderia',
//   'spa' : 'Spa',
//   'theater' : 'Teatro',
//   'terraces' : 'Terrazas',
//   'souvenir-shop' : 'Tienda de souvenirs',
//   'airport-transfer' : 'Traslados Aeropuerto'
// };

// let listChecksCovidKeys = {
//   'protected-medical-area' : 'Area medica protegida',
//   'virtual-check-in-out' : 'Check in / out virtual',
//   'temperature-check' : 'Chequeo de temperatura',
//   'first-aid-kit-available' : 'Kit de primeros auxilios disponibles',
//   'separation-screens-for-personnel' : 'Mamparas de separacion para personal',
//   'contactless-payment-available' : 'Pago sin contacto disponible',
//   'sanitizers-in-common-areas' : 'Sanitizantes en areas comunes',
//   'use-of-specific-cleaning-articles-for-covid' : 'Utilizacion de articulos de limpieza especificos para Covid'
// };

const Info = ({ navigation, route, section = 'all' }) => {

  // const hotelData = useSelector((state) => state?.hotelReducer);
  const { data: hotel } = useContext(HotelContext)
  const { address, amenities, covid, gallery, email, location, name, phone, web, settings, socialNetworks } = hotel;
  const { language } = useContext(UserContext);
  const { data: checkInData } = useContext(CheckInContext);

  // const { title, titleI18n, desc, descI18n } = hotelData.sections.info;
  let locationSrc = null;
  if (location?.lat && location?.lng) {
    locationSrc = `https://maps.google.com/maps?q=loc:${location.lat},${location.lng}&z=12&output=embed`;
  }

  console.log('section', section)

  const data = useMemo(() => {
    console.log('hotel.settings', hotel.settings)
    if (hotel.settings.sections) {
      const _data = hotel.settings.sections.find(i => i.code == "info")
      console.log('_data', _data)
      return _data;
    }
    return {}
  }, [hotel.settings?.sections])

  const mergedPlaceholders = useMemo(
    () => mergeHotelAndCheckinPlaceholders(settings?.placeholders, checkInData?.placeholders),
    [settings?.placeholders, checkInData?.placeholders]
  );

  if (!hotel) return <p>Loading...</p>;


  return (
    <Screen
      section="info"
      headerTranslucid={gallery}
      title={i18nValue(data, 'title', language, mergedPlaceholders)}
    >
      {(section == 'all' || section == 'info') && <div className="header-detail-with-slider">
        {gallery &&
          <Carousel
            controls={true}
            indicators={true}>
            {gallery.map((val, idx) => {
              return (
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={getCDNImage(val)}
                    style={{ objectFit: 'cover' }}
                  />
                </Carousel.Item>
              )
            })}
          </Carousel>}
      </div>}

      {/* <Container style={{marginBottom: 100, marginTop: 50}}> */}
      <Container>
        {(section == 'all' || section == 'info') && <>
          <h5 className="general-title">{i18nValue(data, 'title', language, mergedPlaceholders)}</h5>
          {console.log("data", data)}

          <p className="general-text" style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: i18nValue(data, 'desc', language, mergedPlaceholders) }} />
          
          <SectionBlocksRenderer
            section={data}
            language={language}
            sectionsByCode={hotel.settings?.sections}
            getUrlPath={hotel.getUrlPath}
          />
          {!isHostzArosa(hotel.id) && <>
            <h5 className="general-subtitle">{T('hotel.contact-us')}</h5>
            <p className="general-text">{T('hotel.please-feel')}</p>
            {phone && <>
              <h6 className="general-subtitle">{T("hotel.phones")}</h6>
              <p className="general-text"><a href={"tel:" + phone}>{phone}</a></p>
            </>
            }
            {web && <>
              <h6 className="general-subtitle">{T("hotel.website")}</h6>
              <p className="general-text"><a href={web}>{web}</a></p>
            </>
            }
            {email && <>
              <h6 className="general-subtitle">E-Mail</h6>
              <p className="general-text"><a href={"mailto:" + email}>{email}</a></p>
            </>
            }
            <SocialLinks socialMediaArray={socialNetworks} />
          </>}
        </>}
        {(section == 'all' || section == 'amenities') && amenities && <>
          <div>
            <h5 className="general-subtitle">{T('Hotel amenities and services')}</h5>
            <div style={{ marginBottom: '10px', width: "100%" }}>
              {amenities.map((val, idx) => {
                return (
                  <div>
                    <FontAwesomeIcon style={{ marginRight: "10px", color: '#BBBBBB' }} size="md" icon={faCheck} />
                    <label>{T("hotel." + val)}</label>
                  </div>
                )
              })}
            </div>
          </div>
          {/* <p className="general-text">{T("Please check the rooms for room amenities as they may vary")}</p> */}
        </>}

        {/* desahabilito la seccion covid */}
        {(false && (section == 'all' || section == 'covid') && (covid && covid?.length > 0)) && <>
          <div>
            <h5 className="general-subtitle">Covid</h5>
            <p className="general-text">{T("In order to enjoy our hotel more, we have the following precautions against covid")}</p>
            <div style={{ marginBottom: '10px', width: "100%" }}>
              {covid.map((val) => {
                return (
                  <div>
                    {/* <FontAwesomeIcon style={{marginRight: "10px", color:'#c77f47'}} size="lg" icon={val.icon}/> */}
                    <FontAwesomeIcon style={{ marginRight: "10px", color: '#BBBBBB' }} size="md" icon={faCheckCircle} />
                    <label>{T('hotel.covid.' + val)}</label>
                  </div>
                )
              })}
            </div>
          </div>
        </>}

        {(section == 'all' || section == 'location') && location && <>
          {section == 'location' && <>
            <iframe frameborder="0" style={{ border: "0", width: "100%", height: "60vh", borderRadius: "10px", marginTop: '-70px' }} src={locationSrc} allowfullscreen=""></iframe>
            <Row className="page-header">
              <Col>
                <h1>{T('hotel.location')}</h1>
              </Col>
            </Row>
            <Row className="page-subheader">
              <Col>
                <p className="general-text">{T("maps.how_to_reach_us")}</p>
              </Col>
            </Row>
            <Container className="card-generic mt-3">
              <Row>
                <Col xs={3}>
                  {T("hotel.address")}
                </Col>
                <Col xs={9}>
                  <p className="mb-0 request-items general-text">
                    <a
                      href={location?.lat && location?.lng && `https://maps.google.com/maps/dir/${location?.lat},${location?.lng}/@${location?.lat},${location?.lng}`}
                      target="_blank">
                      {address}
                    </a>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col xs={3}>
                  {T("hotel.phones")}
                </Col>
                <Col xs={9}>
                  <p className="mb-0 request-items general-text"><a href={"tel:" + phone}>{phone}</a></p>
                </Col>
              </Row>
            </Container>
          </>}
          {section != 'location' && <>
            <h5 className="general-subtitle">{T('hotel.location')}</h5>
            <p className="general-text text-left">
              <a
                href={location?.lat && location?.lng && `https://maps.google.com/maps/dir/${location?.lat},${location?.lng}/@${location?.lat},${location?.lng}`}
                target="_blank">
                {address}
              </a>
            </p>
            <iframe height="300" frameborder="0" style={{ border: "0", width: "100%", borderRadius: "10px" }} src={locationSrc} allowfullscreen=""></iframe>
          </>}
        </>}
      </Container>
    </Screen>
  );
}

export default Info;